import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-mini-wizard-wrapper" }
const _hoisted_2 = { class: "gfu-project-mini-wizard _fo" }
const _hoisted_3 = { class: "_pos-r _bgc--white _rounded--common gfu-background-swept" }
const _hoisted_4 = { class: "_pt-3 _px-3" }
const _hoisted_5 = { class: "_flexcol _pa-3 _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_button = _resolveComponent("skeleton-button")
  const _component_detect_overflow = _resolveComponent("detect-overflow")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_detect_overflow, { class: "gfu-project-mini-wizard__content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_skeleton_image)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_skeleton_line),
              _createVNode(_component_skeleton_line),
              _createVNode(_component_skeleton_button, { class: "_mb-6" }),
              _createVNode(_component_skeleton_button)
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}